import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=553b140c&scoped=true&lang=pug&"
import script from "./ModalPage.vue?vue&type=script&lang=js&"
export * from "./ModalPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalPage.vue?vue&type=style&index=0&id=553b140c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b140c",
  null
  
)

export default component.exports